import { useEffect, useState } from "react";

const links = [
  { href: "#gallery", label: "精选图集" },
  { href: "#styles", label: "画风鉴赏" },
  { href: "#hot", label: "热门推荐" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
  { href: "#contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-gemini-line text-lg"></i>
          </span>
          <span className={`font-heading text-lg md:text-xl font-bold tracking-wide ${scrolled ? "text-foreground-950" : "text-white"}`}>
            琉璃神社
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer ${
                  scrolled ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100" : "text-white/85 hover:text-white hover:bg-white/10"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 cursor-pointer"
          >
            开始鉴赏
            <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen(!open)}
            className={`lg:hidden flex h-10 w-10 items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/10"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 md:px-6">
          <ul className="flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600 cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 cursor-pointer"
              >
                开始鉴赏
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}